module.exports = __webpack_public_path__ + "img/cover.ea9012e.webp";